import React from "react"
import PropTypes from "prop-types"
import SbEditable from "storyblok-react"
import Button from "../button"

const CallToAction = ({ blok }) => (
  <SbEditable content={blok}>
    <div
      className={`call-to-action ${blok.bg_color === "--alt" ? " call-to-action--alt" : ""}`}
    >
      <h2 className="call-to-action__title">{blok.title}</h2>
      {blok.primary_button &&
        blok.primary_button.map((content) => (
          <Button
            key={content._uid}
            blok={content}
            className={`call-to-action__btn ${blok.bg_color === "--alt" ? "" : "btn--alt"} btn--sm-wide`}
          />
        ))}
    </div>
  </SbEditable>
)

CallToAction.propTypes = {
  blok: PropTypes.shape({
    title: PropTypes.string,
    primary_button: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
}

export default CallToAction
